import type { SpaceListItem } from '../api/auth';

const TASK_SHELLS = new Set(['rondo', 'affilmaster', 'affilplatform']);

export function taskIdFromUrl(pathname: string, search: string): number | null {
  if (pathname !== '/ukoly') return null;
  const raw = new URLSearchParams(search).get('taskId');
  if (!raw || !/^[1-9]\d*$/.test(raw)) return null;
  const id = Number(raw);
  return Number.isSafeInteger(id) ? id : null;
}

export function spaceForTaskLink(
  primarySpaceId: number,
  activeSpaceId: number | null,
  spaces: SpaceListItem[],
): SpaceListItem | null {
  const available = spaces.filter((s) => s.status === 'active' && s.subdomain && TASK_SHELLS.has(s.slug));
  return available.find((s) => s.id === primarySpaceId)
    ?? available.find((s) => s.id === activeSpaceId)
    ?? available[0]
    ?? null;
}
